import styled from "styled-components";

export const FreePlaySuggestionGiftIconBox = styled.div<{iconUrl: string}>`
    width: 75px;
    height: 75px;
    background-image: url("${props => props.iconUrl}");
    background-size: contain;
    background-repeat: no-repeat;
`